module.exports = __webpack_public_path__ + "img/mem_coupon_font_m.567f7299.jpg";